import styled from 'styled-components';
import { rem } from 'polished';

const MissionContentContainer = styled.span`
    display: block;
    margin-bottom: ${rem(32)};
`;

export default MissionContentContainer;
